import { Controller, useFormContext } from "react-hook-form";
import { Select, SelectItem, SelectProps } from "@heroui/react";

function SelectMultipleInput({
    name,
    options,
    ...props
}: {
    name: string;
    options: { id: string | number; description: string | number }[];
} & Partial<SelectProps>) {
    const { control } = useFormContext();
    return (
        <Controller
            control={control}
            name={name}
            render={({
                field: { onBlur, onChange, value },
                fieldState: { error, invalid },
            }) => {
                return (
                    <Select
                        {...props}
                        onSelectionChange={(e) => {
                            onChange([...e]);
                        }}
                        onBlur={onBlur}
                        isInvalid={invalid}
                        errorMessage={error?.message}
                        selectionMode="multiple"
                        selectedKeys={new Set(value)}
                    >
                        {options.map((option) => (
                            <SelectItem key={option.id}>
                                {option.description?.toString()}
                            </SelectItem>
                        ))}
                    </Select>
                );
            }}
        />
    );
}

export default SelectMultipleInput;
